// The cart drawer and the product page can each pull this asset in, and two
// <script src> tags with the same URL both execute. Keep the first instance so
// its `loaded` set survives and no family is requested twice.
window.PersonalisationFonts = window.PersonalisationFonts || {
  system: ['Arial', 'Courier New', 'Garamond', 'Lucida Grande', 'Monaco', 'Palatino', 'Times New Roman', 'Trebuchet MS'],
  google: {
    Muli: 'Mulish',
    'Open Sans Condensed': 'Open Sans',
    'Source Sans Pro': 'Source Sans 3',
  },
  // Matches the "Printed Name / Number / Initials Font" list on the live site's product options.
  families: [
    'Archivo Black', 'Archivo Narrow', 'Chivo', 'Cormorant Garamond', 'Eczar', 'Inknut Antiqua', 'Lato',
    'Montserrat', 'Open Sans', 'Oswald', 'Poppins', 'Roboto', 'Rubik', 'Space Mono',
  ],

  // Library names Google hosts under another name render via that name.
  familyFor(font) {
    return this.google[font] || font;
  },

  stack(font) {
    const family = String(this.familyFor(font)).replace(/[^\w\s-]/g, '');
    return `"${family}", sans-serif`;
  },

  // Showing every option in its own face means every face has to be on the
  // page, so batch them into one css2?family=A&family=B request rather than
  // fourteen separate <link> round trips.
  load(fonts) {
    this.loaded = this.loaded || new Set();
    const families = [
      ...new Set(
        (Array.isArray(fonts) ? fonts : [fonts])
          .filter((font) => font && !this.system.includes(font))
          .map((font) => this.familyFor(font))
      ),
    ].filter((family) => !this.loaded.has(family));
    if (!families.length) return;
    families.forEach((family) => this.loaded.add(family));
    const query = families
      .map((family) => `family=${encodeURIComponent(family).replace(/%20/g, '+')}`)
      .join('&');
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?${query}&display=swap`;
    document.head.appendChild(link);
  },
};
